import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { MdCheckCircle, MdError } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';

import DownloadFileErrorLogButton from '../DownloadFileErrorLogButton';
import styles from './AdvancementFileRecordsInfo.less';

const AdvancementFileRecordsInfo = ({ item, onDownloadErrorLog }) => (
  <div className={styles.container}>
    <div className={cn(styles.row, styles.imported)}>
      <MdCheckCircle className={styles.icon} />
      <FormattedMessage
        id="advancementHistory.AdvancementFileRecordsInfo.imported"
        values={{ count: item.recordsImported }}
      />
    </div>
    <div className={cn(styles.row, styles.skipped)}>
      <MdError className={styles.icon} />
      <FormattedMessage
        id="advancementHistory.AdvancementFileRecordsInfo.skipped"
        values={{ count: item.recordsSkipped }}
      />
    </div>
    {onDownloadErrorLog && (
      <DownloadFileErrorLogButton
        size="small"
        ghost={false}
        noBorder={false}
        className={styles.downloadButton}
        item={item}
        onClick={onDownloadErrorLog}
      />
    )}
  </div>
);

AdvancementFileRecordsInfo.propTypes = {
  item: PropTypes.object.isRequired,
  onDownloadErrorLog: PropTypes.func,
};

export default AdvancementFileRecordsInfo;
